class GGPredictiveSearch extends HTMLElement{
  connectedCallback(){
    this.input=this.querySelector('input[type="search"]');
    this.results=this.querySelector('[data-predictive-results]');
    this.input.addEventListener('input',this.onInput.bind(this));
    document.addEventListener('click',e=>{if(!this.contains(e.target))this.close();});
    this.input.addEventListener('keydown',e=>{if(e.key==='Escape')this.close();});
  }
  onInput(){
    clearTimeout(this.timer);
    const q=this.input.value.trim();
    if(q.length<2){this.close();return;}
    this.timer=setTimeout(()=>this.fetchResults(q),250);
  }
  async fetchResults(q){
    const url='/search/suggest?q='+encodeURIComponent(q)+'&resources[type]=product,collection,query&resources[limit]=6&section_id=gg-predictive-results';
    try{
      const res=await fetch(url);
      const text=await res.text();
      const doc=new DOMParser().parseFromString(text,'text/html');
      const markup=doc.querySelector('[data-predictive-inner]');
      if(markup){this.results.innerHTML=markup.innerHTML;this.open();}
    }catch(e){this.close();}
  }
  open(){this.results.hidden=false;this.input.setAttribute('aria-expanded','true');}
  close(){this.results.hidden=true;this.input.setAttribute('aria-expanded','false');}
}
customElements.define('gg-predictive-search',GGPredictiveSearch);

class GGDrawer extends HTMLElement{
  connectedCallback(){
    this.panel=this.querySelector('[data-drawer]');
    document.addEventListener('click',e=>{
      const opener=e.target.closest('[data-drawer-open="'+this.id+'"]');
      if(opener){e.preventDefault();this.show();}
      if(e.target.closest('[data-drawer-close]')&&this.contains(e.target))this.hide();
    });
    document.addEventListener('keydown',e=>{if(e.key==='Escape')this.hide();});
  }
  show(){this.panel.hidden=false;document.body.style.overflow='hidden';this.panel.querySelector('[data-drawer-close]')?.focus();}
  hide(){this.panel.hidden=true;document.body.style.overflow='';}
}
customElements.define('gg-drawer',GGDrawer);

// Quantity stepper. Clamps to the input's min/max (max = what's in stock, set
// in Liquid), disables −/+ at the ends, and fires "gg:qty-max" (bubbling) when
// the customer reaches or tries to pass max, so the page can say "Kun X på lager".
class GGQuantity extends HTMLElement{
  connectedCallback(){
    this.input=this.querySelector('input');
    if(!this.input)return;
    this.down=this.querySelector('[data-step="-1"]');
    this.up=this.querySelector('[data-step="1"]');
    this.querySelectorAll('button[data-step]').forEach(b=>b.addEventListener('click',()=>{
      const next=this.clamp(this.value()+parseInt(b.dataset.step,10));
      if(next===this.value()){this.sync();return;}
      this.input.value=next;
      this.sync();
      if(parseInt(b.dataset.step,10)>0&&next>=this.max())this.hitMax();
      this.input.dispatchEvent(new Event('change',{bubbles:true}));
    }));
    // Clamp typed values before the (inline) change handler submits them.
    this.input.addEventListener('input',()=>{
      if(this.input.value==='')return;
      const want=this.value();
      const next=this.clamp(want);
      if(want>next)this.hitMax();
      if(next!==want)this.input.value=next;
      this.sync();
    });
    this.sync();
  }
  min(){return this.input.min!==''?parseInt(this.input.min,10):1;}
  max(){return this.input.max!==''?parseInt(this.input.max,10):Infinity;}
  value(){const v=parseInt(this.input.value,10);return isNaN(v)?this.min():v;}
  clamp(v){return Math.max(this.min(),Math.min(this.max(),v));}
  hitMax(){this.dispatchEvent(new CustomEvent('gg:qty-max',{bubbles:true,detail:{max:this.max()}}));}
  sync(){
    const v=this.value();
    if(this.down)this.down.disabled=v<=this.min();
    if(this.up)this.up.disabled=v>=this.max();
  }
}
customElements.define('gg-quantity',GGQuantity);
